import type { VariantResource } from "@exonn/js-sdk";

// Название варианта: своё или, если своего нет, унаследованное от товара.
// Для унаследованного нужен загруженный товар (include variant.product).
export const variantTitle = (
  variant: Pick<VariantResource, "title" | "title_inherited" | "product">,
): string =>
  (variant.title_inherited ? variant.product?.title : variant.title) ?? "";
